// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCPVjVgtpx9vRv06-Tckv2lUatpAd3yd98",
  authDomain: "braccet-72c50.firebaseapp.com",
  projectId: "braccet-72c50",
  storageBucket: "braccet-72c50.firebasestorage.app",
  messagingSenderId: "989299482022",
  appId: "1:989299482022:web:76ed36c42519094cedc367",
  measurementId: "G-FCWGNQ8S0V"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
// Request additional scopes for Instagram
facebookProvider.addScope('instagram_basic');
facebookProvider.addScope('pages_show_list');

const db = getFirestore(app);

export { auth, provider, facebookProvider, db };
